import { render, staticRenderFns } from "./personalResumeView.vue?vue&type=template&id=bbff79c4&scoped=true&"
import script from "./personalResumeView.vue?vue&type=script&lang=js&"
export * from "./personalResumeView.vue?vue&type=script&lang=js&"
import style0 from "./personalResumeView.vue?vue&type=style&index=0&id=bbff79c4&scoped=true&lang=css&"
import style1 from "./personalResumeView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbff79c4",
  null
  
)

export default component.exports